import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { PsBeaconAccordionItem } from '../shared/BeaconRegister';

const GenericPanel = ({ id, headerText, children, open }) => (
    <PsBeaconAccordionItem id={`${id}-header`} open={open}>
        <Box slot="title">{headerText}</Box>
        <Box
            id={`${id}-body`}
            slot="panel"
            sx={{
                paddingLeft: '16px',
                paddingRight: '52px',
            }}>
            {children}
        </Box>
    </PsBeaconAccordionItem>
);

export default GenericPanel;
